const ENVIRONMENT = environment_config.environment;
const SVG_ID = 'seat-selection-hall-svg';
const CANVAS_ID = 'seat-selection-hall-canvas';
const CANVAS_WIDTH = 800;
const CANVAS_HEIGHT = 600;
const ACTION_MENU_ID = 'action-menu';

const POSITION_LEFT = 'left';
const POSITION_RIGHT = 'right';
const POSITION_LEFT_AND_RIGHT = 'left_and_right';
const SEAT_TYPE_CIRCLE = 'circle';
const DIRECTION_ASC = 'asc';
const DIRECTION_DESC = 'desc';
const NUMBERING_STARTS = 'starts';
const NUMBERING_ENDS = 'ends';
const SEQUENCE_ARABIC = 'arabic';
const SEQUENCE_ARABIC_EVEN = 'arabic_even';
const SEQUENCE_ARABIC_ODD = 'arabic_odd';
const SEQUENCE_ALPHABETIC = 'alphabetic';
const SEQUENCE_ROMAN = 'roman';

const TOOL_SEAT_DRAWER = 'seat_drawer';
const TOOL_SELECTION = 'selection';
const TOOL_SHAPE_DRAWER = 'shape_drawer';
const TOOL_ROUND_TABLE = 'round_table';
const TOOL_RECTANGLE_TABLE = 'rectangle_table';
const TOOL_GENERAL_ADMISSION = 'general_admission';
const TOOL_HALL_SETTINGS = 'hall_settings';

const TRANSFORMATION_MOVE = 'move';
const TRANSFORMATION_ROTATE = 'rotate';
const TRANSFORMATION_RESIZE_EAST = 'resize_east';
const TRANSFORMATION_RESIZE_WEST = 'resize_west';
const TRANSFORMATION_RESIZE_SOUTH = 'resize_south';
const TRANSFORMATION_RESIZE_NORTH = 'resize_north';

const RECTANGLE_TABLE_EDGE_EAST = 'east';
const RECTANGLE_TABLE_EDGE_WEST = 'west';
const RECTANGLE_TABLE_EDGE_SOUTH = 'south';
const RECTANGLE_TABLE_EDGE_NORTH = 'north';

const TEXT_ANCHOR_START = 'start';
const TEXT_ANCHOR_MIDDLE = 'middle';
const TEXT_ANCHOR_END = 'end';
const DOMINANT_BASELINE_MIDDLE = 'middle';

const LABEL_ICON_DISABLED = 'disabled';
const LABEL_ICON_FOR_CASHIER = 'for_cashier';
const LABEL_ICON_RESERVED = 'reserved';

const OBJECT_TYPE_HALL = 'hall';
const OBJECT_TYPE_SECTOR = 'sector';
const OBJECT_TYPE_ROUND_TABLE = 'round_table';
const OBJECT_TYPE_RECTANGLE_TABLE = 'rectangle_table';
const OBJECT_TYPE_ROW = 'row';
const OBJECT_TYPE_SEAT = 'seat';
const OBJECT_TYPE_GENERAL_ADMISSION = 'general_admission';
const OBJECT_TYPE_SHAPE = 'shape';

const KEY_CODE_CTRL = 17;
const KEY_CODE_ALT = 18;

const KEY_CODE_ARROW_UP = 38;
const KEY_CODE_ARROW_LEFT = 37;
const KEY_CODE_ARROW_RIGHT = 39;
const KEY_CODE_ARROW_DOWN = 40;
const KEY_CODE_DELETE = 46;

const KEY_CODE_C = 67;
const KEY_CODE_V = 86;

const AVAILABLE_KEY_CODES = [
    KEY_CODE_CTRL,
    KEY_CODE_ALT,
    KEY_CODE_ARROW_UP,
    KEY_CODE_ARROW_LEFT,
    KEY_CODE_ARROW_RIGHT,
    KEY_CODE_ARROW_DOWN,
    KEY_CODE_DELETE,
    KEY_CODE_C,
    KEY_CODE_V,
];

const ARC_STEP_AMOUNT = 25;

const MIN_VIEW_BOX_ZOOM = 30;
const MAX_VIEW_BOX_ZOOM = 3030;

const SEAT_PURCHASE_STATUS_FREE = 'free';
const SEAT_PURCHASE_STATUS_PURCHASED = 'purchased';
const SEAT_PURCHASE_STATUS_RESERVED = 'reserved';

const GENERAL_ADMISSION_PURCHASE_STATUS_FREE = 'free';
const GENERAL_ADMISSION_PURCHASE_STATUS_SOLD_OUT = 'sold_out';
const GENERAL_ADMISSION_PURCHASE_STATUS_RESERVED = 'reserved';

const IMAGE_ACCEPTED_MIME_TYPES = [
    'image/png',
    'image/jpg',
    'image/jpeg',
];
const IMAGE_MAX_FILE_SIZE = 524288; // 512kb
const INITIAL_VIEW_BOX_SIZE = 1000;
const USER_ONBOARDING_SEAT_SELECTION = 'seat-selection';

export {
    ENVIRONMENT,
    SVG_ID,
    CANVAS_ID,
    ACTION_MENU_ID,

    POSITION_LEFT,
    POSITION_RIGHT,
    POSITION_LEFT_AND_RIGHT,
    DIRECTION_ASC,
    DIRECTION_DESC,
    NUMBERING_ENDS,
    NUMBERING_STARTS,
    SEQUENCE_ALPHABETIC,
    SEQUENCE_ARABIC,
    SEQUENCE_ARABIC_EVEN,
    SEQUENCE_ARABIC_ODD,
    SEQUENCE_ROMAN,

    TOOL_SEAT_DRAWER,
    TOOL_SELECTION,
    TOOL_ROUND_TABLE,
    TOOL_SHAPE_DRAWER,
    TOOL_RECTANGLE_TABLE,
    TOOL_GENERAL_ADMISSION,
    TOOL_HALL_SETTINGS,

    TEXT_ANCHOR_START,
    TEXT_ANCHOR_MIDDLE,
    TEXT_ANCHOR_END,
    DOMINANT_BASELINE_MIDDLE,
    SEAT_TYPE_CIRCLE,

    OBJECT_TYPE_HALL,
    OBJECT_TYPE_SECTOR,
    OBJECT_TYPE_ROUND_TABLE,
    OBJECT_TYPE_ROW,
    OBJECT_TYPE_SEAT,
    OBJECT_TYPE_RECTANGLE_TABLE,
    OBJECT_TYPE_GENERAL_ADMISSION,
    OBJECT_TYPE_SHAPE,

    TRANSFORMATION_MOVE,
    TRANSFORMATION_ROTATE,
    TRANSFORMATION_RESIZE_EAST,
    TRANSFORMATION_RESIZE_WEST,
    TRANSFORMATION_RESIZE_SOUTH,
    TRANSFORMATION_RESIZE_NORTH,

    KEY_CODE_CTRL,
    KEY_CODE_ALT,
    KEY_CODE_ARROW_UP,
    KEY_CODE_ARROW_LEFT,
    KEY_CODE_ARROW_RIGHT,
    KEY_CODE_ARROW_DOWN,
    KEY_CODE_DELETE,
    KEY_CODE_C,
    KEY_CODE_V,
    AVAILABLE_KEY_CODES,

    RECTANGLE_TABLE_EDGE_EAST,
    RECTANGLE_TABLE_EDGE_NORTH,
    RECTANGLE_TABLE_EDGE_SOUTH,
    RECTANGLE_TABLE_EDGE_WEST,

    ARC_STEP_AMOUNT,

    MIN_VIEW_BOX_ZOOM,
    MAX_VIEW_BOX_ZOOM,

    SEAT_PURCHASE_STATUS_FREE,
    SEAT_PURCHASE_STATUS_PURCHASED,
    SEAT_PURCHASE_STATUS_RESERVED,
    IMAGE_ACCEPTED_MIME_TYPES,
    IMAGE_MAX_FILE_SIZE,
    INITIAL_VIEW_BOX_SIZE,
    CANVAS_WIDTH,
    CANVAS_HEIGHT,
    LABEL_ICON_DISABLED,
    LABEL_ICON_FOR_CASHIER,
    LABEL_ICON_RESERVED,
    USER_ONBOARDING_SEAT_SELECTION,

    GENERAL_ADMISSION_PURCHASE_STATUS_FREE,
    GENERAL_ADMISSION_PURCHASE_STATUS_SOLD_OUT,
    GENERAL_ADMISSION_PURCHASE_STATUS_RESERVED,
};
